import { useTranslation } from 'react-i18next';

import "../styles/Certificates.css";
import CertificateCardGrid from "./CertificateCardGrid";
import ScrollDownIndicator from "./ScrollDownIndicator";

const CertificatesPageComponent = () => {

    const { t } = useTranslation();

    const certificates = [
        {
            year: "2025",
            items: [
                { title: "certificate_iwe_title", numberOfCertificates: 66 },
                { title: "certificate_ewe_title", numberOfCertificates: 66 },
                { title: "certificate_iwi_c_title", numberOfCertificates: 29 },
                { title: "certificate_ewi_c_title", numberOfCertificates: 29 },
                { title: "certificate_iwi_s_title", numberOfCertificates: 14 },
                { title: "certificate_ewi_s_title", numberOfCertificates: 14 },
                { title: "certificate_iwt_title", numberOfCertificates: 1 },
                { title: "certificate_ewt_title", numberOfCertificates: 1 },
                { title: "certificate_iws_title", numberOfCertificates: 14 },
                { title: "certificate_ews_title", numberOfCertificates: 14 },
                { title: "certificate_iwsd_title", numberOfCertificates: 9 },
                { title: "certificate_c_iwe_title", numberOfCertificates: 3 },
            ],
            cumulativeItems: [
                { title: "certificate_iwi_c_title", numberOfCertificates: 492 },
                { title: "certificate_iwi_s_title", numberOfCertificates: 117 },
                { title: "certificate_iwi_b_title", numberOfCertificates: 10 },
                { title: "certificate_iwe_title", numberOfCertificates: 1071 },
                { title: "certificate_iwt_title", numberOfCertificates: 7 },
                { title: "certificate_ewt_title", numberOfCertificates: 7 },
                { title: "certificate_iws_title", numberOfCertificates: 158 },
                { title: "certificate_ews_title", numberOfCertificates: 158 },
                { title: "certificate_iwsd_s_title", numberOfCertificates: 12 },
                { title: "certificate_iwsd_c_title", numberOfCertificates: 12 },
                { title: "certificate_ewe_title", numberOfCertificates: 1401 },
                { title: "certificate_ewip_title", numberOfCertificates: 594 },
                { title: "certificate_c_iwe_title", numberOfCertificates: 38 },
            ],
        },
        {
            year: "2024",
            items: [
                { title: "certificate_iwe_title", numberOfCertificates: 64 },
                { title: "certificate_ewe_title", numberOfCertificates: 64 },
                { title: "certificate_iwi_c_title", numberOfCertificates: 70 },
                { title: "certificate_ewi_c_title", numberOfCertificates: 70 },
                { title: "certificate_iwi_s_title", numberOfCertificates: 16 },
                { title: "certificate_ewi_s_title", numberOfCertificates: 16 },
                { title: "certificate_iwt_title", numberOfCertificates: 1 },
                { title: "certificate_ewt_title", numberOfCertificates: 1 },
                { title: "certificate_iws_title", numberOfCertificates: 9 },
                { title: "certificate_ews_title", numberOfCertificates: 9 },
                { title: "certificate_c_iwe_title", numberOfCertificates: 2 },
            ],
            cumulativeItems: [
                { title: "certificate_iwi_c_title", numberOfCertificates: 463 },
                { title: "certificate_iwi_s_title", numberOfCertificates: 103 },
                { title: "certificate_iwi_b_title", numberOfCertificates: 10 },
                { title: "certificate_iwe_title", numberOfCertificates: 1005 },
                { title: "certificate_iwt_title", numberOfCertificates: 6 },
                { title: "certificate_ewt_title", numberOfCertificates: 6 },
                { title: "certificate_iws_title", numberOfCertificates: 144 },
                { title: "certificate_ews_title", numberOfCertificates: 144 },
                { title: "certificate_iwsd_title", numberOfCertificates: 9 },
                { title: "certificate_ewe_title", numberOfCertificates: 1335 },
                { title: "certificate_ewip_title", numberOfCertificates: 551 },
                { title: "certificate_c_iwe_title", numberOfCertificates: 35 },
            ],
        },
    ];

    return (
        <div className="certificates-page">
            <div className="certificates-grid-title-container">
                <p className="certificates-grid-title">{t('certifications_title')}</p>
                <h1 className="certificates-grid-subtitle">{t('certifications_subtitle')}</h1>
                <p className="certificates-grid-text">
                    {t('certifications_description')}
                </p>
                <ScrollDownIndicator targetId="certificates-content" />
            </div>
            <div className="certificates-grid" id="certificates-content">
                <CertificateCardGrid certificates={certificates} />
            </div>
        </div>
    );
}
export default CertificatesPageComponent;
